import $ from 'jquery';
export default {
  name: 'liste-visites-medicales',
  components: {},
  props: [],
  data () {
    return {
      filter: "",
      fields: [
        { key: 'index', label: 'N°' },
        { key: 'annee', label: 'Année' },
        { key: 'date_debut', label: 'Debut'},
        { key: 'date_fin', label: 'Fin' },
    ],

    }
  },
  computed: {
    visites(){
      return this.$store.getters["societeVisitesMedicales"]
    }
  },
  mounted () {
    let the_role = $(".liste-visites-medicales tr:eq(2)").hide()
    console.log(the_role)
  },
  updated() {
    let the_role = $(".liste-visites-medicales tr:eq(2)").hide()
    console.log(the_role)
  },
  methods: {
    clickVisite: function(visite){
      this.$emit("onClickVisite",visite)
    }

  }
}


